import { render, staticRenderFns } from "./resumefour_template.vue?vue&type=template&id=5356ab65&"
import script from "./resumefour_template.vue?vue&type=script&lang=js&"
export * from "./resumefour_template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports